import { render, staticRenderFns } from "./TakipForm.vue?vue&type=template&id=c2a2909a&scoped=true"
import script from "./TakipForm.vue?vue&type=script&lang=ts"
export * from "./TakipForm.vue?vue&type=script&lang=ts"
import style0 from "./TakipForm.vue?vue&type=style&index=0&id=c2a2909a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a2909a",
  null
  
)

export default component.exports